import images from "./images";

const projects = [
    {
        id: 1,
        image: images.project1,
        title: "Residential Roof",
        details: {
            date: "February 2, 2024",
            client: "Residential Homeowners",
            category: "Roof Installation",
            duration: "Varies based on project size",
            location: "Nationwide Residential Roofing Services",
            cost: "Customized pricing based on project requirements",
            leadArchitect: "John Rooferson"
        },
        paragraphs: [
            "Ensure your home is protected with our expert residential roof installation services. We offer top-quality materials and precision craftsmanship to deliver a durable and aesthetically pleasing roof.",
            "Our residential roof installation services provide a range of roofing options, from asphalt shingles to metal roofing, ensuring the best fit for your home’s style and climate. We focus on durability, weather resistance, and enhancing your home’s curb appeal."
        ],
        gallery: [
            images.project1Gallery1,
            images.project1Gallery2,
            images.project1Gallery3,
            images.project1Gallery4,
            images.project1Gallery5,
            images.project1Gallery6
        ],
        challenges: [
            "Precise Roof Measurements and Planning",
            "Weatherproofing and Insulation",
            "Seamless Integration with Existing Roof Structures"
        ],
        solutions: [
            "Professional Installation Techniques",
            "Premium Roofing Materials Selection",
            "Post-Installation Inspection and Maintenance Guidelines"
        ],
        results: [
            "Durable and Weather-Resistant Roofs",
            "Enhanced Home Value and Curb Appeal",
            "Long-Term Protection and Peace of Mind"
        ],
    },
    {
        id: 2,
        image: images.project2,
        title: "Emergency Roof Repair",
        details: {
            date: "March 10, 2024",
            client: "Urgent Service Homeowners",
            category: "Roof Repair",
            duration: "Immediate response with rapid turnaround",
            location: "Local and Regional Emergency Services",
            cost: "Emergency rates apply based on damage severity",
            leadArchitect: "Sarah Quickfix"
        },
        paragraphs: [
            "When roof damage strikes unexpectedly, our emergency roof repair service is ready to respond immediately. We provide fast, reliable, and efficient repairs to prevent further damage and restore safety.",
            "Our emergency repair solutions are tailored to stabilize your roof quickly while planning for a long-term fix. Whether it’s storm damage, leaks, or fallen debris, we have the tools and expertise to handle it all on the spot."
        ],
        gallery: [
            images.project2Gallery1,
            images.project2Gallery2,
            images.project2Gallery3,
            images.project2Gallery4,
            images.project2Gallery5,
            images.project2Gallery6
        ],
        challenges: [
            "Severe Weather Conditions and Time Sensitivity",
            "Assessing Damage Without Full Inspection Access",
            "Ensuring Temporary Fixes Are Secure and Safe"
        ],
        solutions: [
            "24/7 Emergency Response Teams",
            "Temporary Sealing and Leak Control",
            "Follow-up Inspection and Permanent Repair Planning"
        ],
        results: [
            "Immediate Risk Mitigation and Safety Restoration",
            "Minimized Property Damage and Water Intrusion",
            "Preparedness Plan for Future Emergencies"
        ],
    },
    {
        id: 3,
        image: images.project3,
        title: "Commercial Roof",
        details: {
            date: "January 12, 2024",
            client: "Business Property Owners",
            category: "Roof Installation",
            duration: "Project duration varies by building size",
            location: "Commercial Sites Nationwide",
            cost: "Tailored pricing based on roofing system and scale",
            leadArchitect: "Mark Builderton"
        },
        paragraphs: [
            "Protect your commercial property with our top-tier commercial roof installation services. We specialize in durable, energy-efficient roofing systems built to withstand heavy use and extreme weather.",
            "From flat roofing systems to specialized industrial coverings, we deliver tailored solutions that align with your structural requirements and budget. Our installations ensure longevity, performance, and compliance with all safety codes."
        ],
        gallery: [
            images.project3Gallery1,
            images.project3Gallery2,
            images.project3Gallery3,
            images.project3Gallery4,
            images.project3Gallery5,
            images.project3Gallery6
        ],
        challenges: [
            "Adhering to Commercial Building Regulations",
            "Minimizing Downtime During Business Hours",
            "Handling Large Surface Areas and Complex Layouts"
        ],
        solutions: [
            "Compliance with Local Codes and Safety Standards",
            "Scheduled Workflows to Avoid Business Disruption",
            "High-Performance Roofing Materials and Tools"
        ],
        results: [
            "A Strong, Resilient Roofing System",
            "Improved Building Efficiency and Energy Savings",
            "Enhanced Property Value and Protection"
        ],
    },
    {
        id: 4,
        image: images.project4,
        title: "Skylight Installation",
        details: {
            date: "March 22, 2024",
            client: "Modern Homeowners",
            category: "Specialty Roofing",
            duration: "Depends on skylight type and roof structure",
            location: "Available in select urban and suburban areas",
            cost: "Custom pricing based on design and placement",
            leadArchitect: "Sarah Lightwell"
        },
        paragraphs: [
            "Illuminate your space with natural light through our expert skylight installation services. Designed to enhance ambiance and reduce energy consumption, our skylights add elegance and efficiency to your home.",
            "We install a range of skylight styles—from fixed and ventilated to tubular designs—ensuring a perfect fit for your roof type and room layout. Our team prioritizes leak-proof sealing and structural integrity for lasting performance."
        ],
        gallery: [
            images.project4Gallery1,
            images.project4Gallery2,
            images.project4Gallery3,
            images.project4Gallery4,
            images.project4Gallery5,
            images.project4Gallery6
        ],
        challenges: [
            "Accurate Roof Cutout and Framing",
            "Preventing Leaks and Moisture Intrusion",
            "Maximizing Light While Minimizing Heat Gain"
        ],
        solutions: [
            "Precision Installation by Certified Experts",
            "High-Quality Flashing and Sealant Systems",
            "Energy-Efficient, UV-Protected Glass Options"
        ],
        results: [
            "Brightened Indoor Spaces with Natural Light",
            "Improved Energy Efficiency and Ventilation",
            "Stylish Enhancement to Home Design"
        ],
    },
    {
        id: 5,
        image: images.project5,
        title: "Shingle Replacement",
        details: {
            date: "April 5, 2024",
            client: "Suburban Homeowners",
            category: "Roof Repair",
            duration: "1 to 2 days depending on roof size",
            location: "Local and regional service availability",
            cost: "Affordable pricing based on roof area and shingle type",
            leadArchitect: "Mark Shingler"
        },
        paragraphs: [
            "Maintain the integrity of your roof with our professional shingle replacement services. Whether due to aging, storm damage, or general wear, we ensure timely and durable shingle upgrades to restore your roof’s performance.",
            "We use top-grade asphalt, wood, or composite shingles to match your home’s style while providing excellent weather resistance. Our process includes thorough inspection, removal of damaged shingles, and precise installation of new ones."
        ],
        gallery: [
            images.project5Gallery1,
            images.project5Gallery2,
            images.project5Gallery3,
            images.project5Gallery4,
            images.project5Gallery5,
            images.project5Gallery6
        ],
        challenges: [
            "Identifying Hidden Roof Damage",
            "Matching Existing Shingle Color and Style",
            "Ensuring Seamless Waterproofing"
        ],
        solutions: [
            "Comprehensive Roof Inspection and Assessment",
            "Wide Selection of Quality Shingles",
            "Expert Installation with Waterproof Barriers"
        ],
        results: [
            "Revitalized Roof Appearance and Functionality",
            "Extended Roof Lifespan",
            "Protection Against Leaks and Weather Damage"
        ],
    },
    {
        id: 6,
        image: images.project6,
        title: "Solar Panel Installation",
        details: {
            date: "April 10, 2024",
            client: "Eco-Conscious Homeowners",
            category: "Specialty Roofing",
            duration: "2 to 4 days depending on system size",
            location: "Available in solar-permitted service areas",
            cost: "Custom pricing based on panel type and roof size",
            leadArchitect: "Elena Solara"
        },
        paragraphs: [
            "Maximize energy efficiency and reduce utility costs with our expert solar panel installation services. We integrate high-performance solar systems directly onto your roof for seamless aesthetics and functionality.",
            "Our team handles everything from site assessment and panel positioning to mounting and system integration. We focus on optimizing sunlight exposure while maintaining the structural integrity and weatherproofing of your roof."
        ],
        gallery: [
            images.project6Gallery1,
            images.project6Gallery2,
            images.project6Gallery3,
            images.project6Gallery4,
            images.project6Gallery5,
            images.project6Gallery6
        ],
        challenges: [
            "Optimizing Sunlight Exposure Based on Roof Angle",
            "Maintaining Roof Integrity During Installation",
            "Complying with Local Solar Installation Codes"
        ],
        solutions: [
            "Advanced Solar Site Analysis Tools",
            "Secure Mounting Techniques with Weatherproof Seals",
            "Certified Installers with Code Knowledge"
        ],
        results: [
            "Efficient and Sustainable Energy Production",
            "Increased Property Value",
            "Long-Term Savings on Energy Bills"
        ],
    }

];

export default projects;